import { library } from '@fortawesome/fontawesome-svg-core';

import {faUsers} from '@fortawesome/free-solid-svg-icons/faUsers';
import {faListAlt} from '@fortawesome/free-solid-svg-icons/faListAlt';
import {faEnvelopeOpenText} from '@fortawesome/free-solid-svg-icons/faEnvelopeOpenText';
import {faEdit} from '@fortawesome/free-solid-svg-icons/faEdit';
import {faKey} from '@fortawesome/free-solid-svg-icons/faKey';
import {faUserSecret} from '@fortawesome/free-solid-svg-icons/faUserSecret';
import {faFileDownload} from '@fortawesome/free-solid-svg-icons/faFileDownload';
import {faHistory} from '@fortawesome/free-solid-svg-icons/faHistory';
import {faCheckCircle} from '@fortawesome/free-solid-svg-icons/faCheckCircle';
import {faSignOutAlt} from '@fortawesome/free-solid-svg-icons/faSignOutAlt';
import {faUserCircle} from '@fortawesome/free-solid-svg-icons/faUserCircle';
import {faCcVisa} from '@fortawesome/free-brands-svg-icons/faCcVisa';
import {faCcMastercard} from '@fortawesome/free-brands-svg-icons/faCcMastercard';
import {faCcAmex} from '@fortawesome/free-brands-svg-icons/faCcAmex';
import {faCcDiscover} from '@fortawesome/free-brands-svg-icons/faCcDiscover';
import {faCcJcb} from '@fortawesome/free-brands-svg-icons/faCcJcb';
import {faCcDinersClub} from '@fortawesome/free-brands-svg-icons/faCcDinersClub';
import {faCreditCard} from '@fortawesome/free-regular-svg-icons/faCreditCard';
import {faTag} from '@fortawesome/free-solid-svg-icons/faTag';
import {faInfoCircle} from '@fortawesome/free-solid-svg-icons/faInfoCircle';

export function faLibInit() {
  library.add(
    faUsers,
    faListAlt,
    faEnvelopeOpenText,
    faEdit,
    faKey,
    faUserSecret,
    faFileDownload,
    faHistory,
    faCheckCircle,
    faSignOutAlt,
    faUserCircle,
    faCcVisa,
    faCcMastercard,
    faCreditCard,
    faCcAmex,
    faCcDiscover,
    faCcJcb,
    faCcDinersClub,
    faTag,
    faInfoCircle
    );
}
